import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import {Message} from "element-ui";
import Main from '../views/Main.vue'
import Login from '../views/Login.vue'
import Account from '../views/Account.vue'
import Announce from '../views/Announce.vue'
import Order from '../views/Order.vue'
import Store from '../views/Store.vue'
import User from '../views/User.vue'
import Log from '../views/Log.vue'
import {getAuth, isLogin} from "@/api";

Vue.use(VueRouter)

export const ROUTE = {
    MAIN: 'Main',
    LOGIN: 'Login'
}
const routes: Array<RouteConfig> = [
    {path: '*', redirect: '/'},
    {path: '/login', component: Login, name: ROUTE.LOGIN, meta: {authLevel: 0}},
    {path: '/user', component: User, meta: {authLevel: 0}},
    {path: '/account', component: Account, meta: {authLevel: 1}},
    {path: '/announce', component: Announce, meta: {authLevel: 0}},
    {path: '/store', component: Store, meta: {authLevel: 0}},
    {path: '/order', component: Order, meta: {authLevel: 0}},
    {path: '/log', component: Log, meta: {authLevel: 0}},
    {path: '/', component: Main, name: ROUTE.MAIN, meta: {authLevel: 0}}
]

const router = new VueRouter({
    mode: 'hash',
    routes
})
router.beforeEach((to, from, next) => {
    if (isLogin()) {
        console.log('user already login');
        if (to.name !== ROUTE.LOGIN) {
            if (getAuth() >= to.meta.authLevel) {
                next()
            } else {
                Message.warning('權限不足')
                next({name: ROUTE.MAIN})
            }
        } else {
            next({name: ROUTE.MAIN})
        }
    } else {
        console.log('user not log in');
        if (to.name !== ROUTE.LOGIN) {
            Message.warning('Please Login first')
            next({name: ROUTE.LOGIN})
        } else {
            next()
        }
    }
})

export default router
